import { ChangeDetectionStrategy, Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from "@ngrx/store";
import { interval, Observable, Subscription } from "rxjs";
import * as fromNotifications from '../../+state/notifications/notifications.selectors'
import { Notification } from "../../+state/notifications/notifications.models";
import * as NotificationsActions from '../../+state/notifications/notifications.actions'
import { tap } from 'rxjs/operators';

@Component({
  selector: 'avano-notifications-container',
  templateUrl: './avano-notifications-container.component.html',
  styleUrls: ['./avano-notifications-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvanoNotificationsContainerComponent implements OnInit, OnDestroy {
  notifications$: Observable<Notification[]> = this.store.select(fromNotifications.getNotificationsFiltered)

  unread$: Observable<boolean> = this.store.select(fromNotifications.getIsUnread);
  unreadCount$: Observable<number> = this.store.select(fromNotifications.getUnreadCount);
  subscription: Subscription = new Subscription();

  isOpen: boolean;

  private readonly interval = 20 * 1000;

  constructor(private store: Store){}

  ngOnInit(): void {
    this.store.dispatch(NotificationsActions.load())
    const subscription = interval(this.interval).pipe(
      tap(() => {
        this.store.dispatch(NotificationsActions.load())
      })
    ).subscribe();
    this.subscription.add(subscription);
  }

  markAsRead(id: number): void {
    this.store.dispatch(NotificationsActions.markAsRead({notification: {id, changes: {isRead: true}}}))
  }

  delete(id: number): void {
    this.store.dispatch(NotificationsActions.deleteOne({id}))
  }

  downloadReport({reportId, filename}): void {
    this.store.dispatch(NotificationsActions.downloadReport({reportId,filename}))
  }

  toggleUnread(unread: boolean): void {
    this.store.dispatch(NotificationsActions.toggleUnread({unread}));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
